// js for shopable video
class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector(".video-item__popup");
    this.init();
  }
  init() {
    if (this.popupDiv || !this.classList.contains("instagram-item")) {
      window.addEventListener("resize", this.responsive.bind(this));
      window.addEventListener("load", this.responsive.bind(this));
      this.addEventListener("click", this.onClick.bind(this));
      this.connectedCallback();
    }
  }
  onClick() {
    const template = this.closest(".shopable-video-section").querySelector(
      "template"
    );
    if (template) {
      const content =
        template.content.firstElementChild.cloneNode(true).outerHTML;
      const nav = `<div class="swiper-arrow swiper-prev-modal transition swiper-button-prev bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>
          </div>
          <div class="swiper-arrow swiper-next-modal transition swiper-button-next bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>
          </div>`;
      this.initPopup(content, nav);
      this.findActiveSlideModal();
      const modal = this.modal;
      if (!modal) return;
      this.setupExclusivePlayback(modal);
      const productPopupDiv = modal.modalBoxContent.querySelectorAll(
        ".video-item__product-mobile"
      );
      if (productPopupDiv.length > 0){
        productPopupDiv.forEach((div) => {
          div.addEventListener(
            "click",
            this.onClickMobile.bind(this)
          );
        });
      }
    }
  }

  // Pause every <video> inside `root` except `except`.
  pauseVideos(root, except = null) {
    if (!root) return;
    root.querySelectorAll("video").forEach((video) => {
      if (video !== except && !video.paused) video.pause();
    });
  }

  /*
   * Popup video behaviour (desktop + mobile):
   *  - Native autoplay/muted attributes are removed from popup videos, so the
   *    browser does NOT start all 4 videos in different states.
   *  - JS starts ONLY the active slide's video, the same way for every slide
   *    (first video or any other): with sound, because the visitor just
   *    clicked / swiped (user gesture). If the browser blocks sound
   *    (e.g. some mobile browsers), it falls back to muted autoplay.
   *  - If the visitor mutes/unmutes with the player controls, that choice is
   *    remembered for the next slides.
   *  - Only one video plays at a time; closing the popup stops everything.
   */
  setupExclusivePlayback(modal) {
    const container = modal.modalBoxContent;
    if (!container) return;

    const videos = container.querySelectorAll("video");
    if (!videos.length) return;

    // Remember whether theme setting "Auto Play" is ON, then strip native
    // attributes so JS controls everything consistently.
    const state = { muted: false, programmatic: false };
    videos.forEach((video) => {
      if (video.hasAttribute("autoplay")) video.dataset.shouldAutoplay = "true";
      video.removeAttribute("autoplay");
      video.removeAttribute("muted");
      video.muted = false;
      video.defaultMuted = false;
    });

    const getSwiper = () => {
      const el = container.querySelector("slide-section-popup");
      return el && el.swiper;
    };
    const getActiveSlide = () => {
      const sw = getSwiper();
      return sw && sw.slides ? sw.slides[sw.activeIndex] : null;
    };

    const playVideo = (video) => {
      if (!video.paused) return;
      state.programmatic = true;
      video.muted = state.muted;
      state.programmatic = false;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === "function") {
        attempt.catch(() => {
          // Browser blocked playback with sound -> retry muted so the video
          // still starts (visitor can unmute from controls).
          if (state.muted) return;
          state.programmatic = true;
          video.muted = true;
          state.programmatic = false;
          const retry = video.play();
          if (retry && typeof retry.catch === "function") retry.catch(() => {});
        });
      }
    };

    // Start the active slide's video, stop all the others.
    const syncActiveVideo = () => {
      const activeSlide = getActiveSlide();
      container.querySelectorAll("video").forEach((video) => {
        const isActive = activeSlide && activeSlide.contains(video);
        if (!isActive) {
          if (!video.paused) video.pause();
          return;
        }
        if (video.dataset.shouldAutoplay === "true") playVideo(video);
      });
    };

    // Visitor's own mute / unmute choice (via player controls) is remembered.
    container.addEventListener(
      "volumechange",
      (event) => {
        if (state.programmatic) return;
        const target = event.target;
        if (target instanceof HTMLVideoElement) state.muted = target.muted;
      },
      true
    );

    // Whenever a video starts, make sure only the active one keeps playing.
    // ("play" does not bubble, so listen in the capture phase.)
    container.addEventListener(
      "play",
      (event) => {
        const current = event.target;
        if (!(current instanceof HTMLVideoElement)) return;
        const activeSlide = getActiveSlide();
        if (activeSlide && !activeSlide.contains(current)) {
          current.pause();
          return;
        }
        this.pauseVideos(container, current);
        // Also silence any unmuted video elsewhere on the page.
        document.querySelectorAll("video").forEach((video) => {
          if (video !== current && !video.paused && !video.muted) video.pause();
        });
      },
      true
    );

    const swiper = getSwiper();
    if (swiper && typeof swiper.on === "function") {
      swiper.on("slideChange", syncActiveVideo);
      swiper.on("slideChangeTransitionEnd", syncActiveVideo);
    }

    syncActiveVideo();
    // Safety re-sync after the modal finished rendering / swiper positioned.
    setTimeout(syncActiveVideo, 300);
  }

  findActiveSlideModal() {
    const modal = this.modal;
    if (!modal) return;
    const swiperContainer = modal.modalBoxContent.querySelector(
      "slide-section-popup"
    );
    if (!swiperContainer) return;
    const position = this.dataset.position;
    if (!position) return;
    if (position !== null && !isNaN(parseInt(position))) {
      const slideIndex = parseInt(position);
      swiperContainer.swiper.slideTo(slideIndex, 0, false);
    } else {
      swiperContainer.swiper.slideTo(0, 0, false);
    }
  }

  onCloseEvent() {
    const popup = document.querySelector(".tingle-modal.shopable-video");
    if (!popup) return;
    // Stop all audio when the popup is closed.
    this.pauseVideos(popup);
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    productInformation.classList.add("hidden");
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const videos = this.querySelectorAll("video");
      videos.forEach((video) => {
        const dataSrc = video.dataset.src;
        if (dataSrc) {
          video.src = dataSrc;
          video.removeAttribute("data-src");
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }
  responsive() {
    const productDivs = document.querySelectorAll(
      ".shopable-video__product-information"
    );
    if (productDivs.length != 0) {
      if (window.innerWidth >= 768) {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.remove("hidden");
        });
      } else {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.add("hidden");
        });
      }
    }
  }
  onClickMobile(event) {
    const _this = this;
    const currentTarget = event.currentTarget;
    const popup = currentTarget.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = false;
    slidePopup.swiper.unsetGrabCursor();
    productInformation.classList.remove("hidden");
    popup.classList.add("open");
    _this.modal.modalCloseBtn.style.display = "none";
  }
}
customElements.define("shopable-video", ShopableVideo);

class SlideSectionPopup extends SlideSection {
  constructor() {
    super();
  }
}
customElements.define("slide-section-popup", SlideSectionPopup);

class ShopableOverlay extends ShopableVideo {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    const currentTarget = event.currentTarget;
    const modal = currentTarget.closest(".shopable-video");
    const popup = currentTarget?.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    const modalCloseBtn = modal?.querySelector(".tingle-modal__close");
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = true;
    slidePopup.swiper.setGrabCursor();
    productInformation.classList.add("hidden");
    popup.classList.remove("open");
    modalCloseBtn.removeAttribute("style");
  }
}
customElements.define("shopable-overlay", ShopableOverlay);

class ButtonCloseShopable extends ShopableOverlay {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }
}
customElements.define("button-close-shopable", ButtonCloseShopable);

// // js for shopable video
// class ShopableVideo extends PopupBase {
//   constructor() {
//     super();
//     this.popupDiv = this.querySelector(".video-item__popup");
//     this.init();
//   }
//   init() {
//     if (this.popupDiv || !this.classList.contains("instagram-item")) {
//       window.addEventListener("resize", this.responsive.bind(this));
//       window.addEventListener("load", this.responsive.bind(this));
//       this.addEventListener("click", this.onClick.bind(this));
//       this.connectedCallback();
//     }
//   }
//   onClick() {
//     const template = this.closest(".shopable-video-section").querySelector(
//       "template"
//     );
//     if (template) {
//       const content =
//         template.content.firstElementChild.cloneNode(true).outerHTML;
//       const nav = `<div class="swiper-arrow swiper-prev-modal transition swiper-button-prev bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
//             <svg width="6" height="11" fill="none">
//               <use href="#icon-back"></use>
//             </svg>
//           </div>
//           <div class="swiper-arrow swiper-next-modal transition swiper-button-next bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
//             <svg width="6" height="11" fill="none">
//               <use href="#icon-next"></use>
//             </svg>
//           </div>`;
//       this.initPopup(content, nav);
//       this.findActiveSlideModal();
//       const modal = this.modal;
//       if (!modal) return;
//       const productPopupDiv = modal.modalBoxContent.querySelectorAll(
//         ".video-item__product-mobile"
//       );
//       if (productPopupDiv.length > 0){
//         productPopupDiv.forEach((div) => {
//           div.addEventListener(
//             "click",
//             this.onClickMobile.bind(this)
//           );
//         });
//       }
//     }
//   }

//   findActiveSlideModal() {
//     const modal = this.modal;
//     if (!modal) return;
//     const swiperContainer = modal.modalBoxContent.querySelector(
//       "slide-section-popup"
//     );
//     if (!swiperContainer) return;
//     const position = this.dataset.position;
//     if (!position) return;
//     if (position !== null && !isNaN(parseInt(position))) {
//       const slideIndex = parseInt(position);
//       swiperContainer.swiper.slideTo(slideIndex, 0, false);
//     } else {
//       swiperContainer.swiper.slideTo(0, 0, false);
//     }
//   }

//   onCloseEvent() {
//     const popup = document.querySelector(".tingle-modal.shopable-video");
//     if (!popup) return;
//     const productInformation = popup.querySelector(
//       ".shopable-video__product-information"
//     );
//     if (!productInformation) return;
//     productInformation.classList.add("hidden");
//   }
//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//       const videos = this.querySelectorAll("video");
//       videos.forEach((video) => {
//         const dataSrc = video.dataset.src;
//         if (dataSrc) {
//           video.src = dataSrc;
//           video.removeAttribute("data-src");
//         }
//       });
//     };

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 200px 0px",
//     }).observe(this);
//   }
//   responsive() {
//     const productDivs = document.querySelectorAll(
//       ".shopable-video__product-information"
//     );
//     if (productDivs.length != 0) {
//       if (window.innerWidth >= 768) {
//         const flexDiv = this.popupDiv?.querySelector(
//           ".video-item__popup--flex"
//         );
//         if (!flexDiv) return;
//         productDivs.forEach((div) => {
//           div.classList.remove("hidden");
//         });
//       } else {
//         const flexDiv = this.popupDiv?.querySelector(
//           ".video-item__popup--flex"
//         );
//         if (!flexDiv) return;
//         productDivs.forEach((div) => {
//           div.classList.add("hidden");
//         });
//       }
//     }
//   }
//   onClickMobile(event) {
//     const _this = this;
//     const currentTarget = event.currentTarget;
//     const popup = currentTarget.closest(".video-item__popup");
//     if (!popup) return;
//     const productInformation = popup.querySelector(
//       ".shopable-video__product-information"
//     );
//     if (!productInformation) return;
//     const slidePopup = document.querySelector("slide-section-popup");
//     slidePopup.swiper.allowTouchMove = false;
//     slidePopup.swiper.unsetGrabCursor();
//     productInformation.classList.remove("hidden");
//     popup.classList.add("open");
//     _this.modal.modalCloseBtn.style.display = "none";
//   }
// }
// customElements.define("shopable-video", ShopableVideo);

// class SlideSectionPopup extends SlideSection {
//   constructor() {
//     super();
//   }
// }
// customElements.define("slide-section-popup", SlideSectionPopup);

// class ShopableOverlay extends ShopableVideo {
//   constructor() {
//     super();
//     this.addEventListener("click", this.onClick.bind(this));
//   }

//   onClick(event) {
//     const currentTarget = event.currentTarget;
//     const modal = currentTarget.closest(".shopable-video");
//     const popup = currentTarget?.closest(".video-item__popup");
//     if (!popup) return;
//     const productInformation = popup.querySelector(
//       ".shopable-video__product-information"
//     );
//     const modalCloseBtn = modal?.querySelector(".tingle-modal__close");
//     if (!productInformation) return;
//     const slidePopup = document.querySelector("slide-section-popup");
//     slidePopup.swiper.allowTouchMove = true;
//     slidePopup.swiper.setGrabCursor();
//     productInformation.classList.add("hidden");
//     popup.classList.remove("open");
//     modalCloseBtn.removeAttribute("style");
//   }
// }
// customElements.define("shopable-overlay", ShopableOverlay);

// class ButtonCloseShopable extends ShopableOverlay {
//   constructor() {
//     super();
//     this.addEventListener("click", this.onClick.bind(this));
//   }
// }
// customElements.define("button-close-shopable", ButtonCloseShopable);